import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import LoadScript from 'vue-plugin-load-script'
import Clipboard from 'v-clipboard'
import VueClipboard from 'vue-clipboard2'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(Clipboard)

Vue.config.productionTip = false
Vue.use(LoadScript)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
